// extracted by mini-css-extract-plugin
export default {"container":"RetentionDateInfo_container__ynQ4F","warning":"RetentionDateInfo_warning__aFPIL","tooltip":"RetentionDateInfo_tooltip__xuC5+"};